export default "__VITE_ASSET__BxmJC_0x__"